import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallConnectionQuality } from '@gem/call/CallProviders/callProviders.constants';
import { Call } from '@gem/call/CallStore/Call';
import { IcNetwork16Icon, IcNetworkGood16Icon, IcNetworkPoor16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './ConnectionQuality.styles.m.css';

interface ICallTimeProps {
  call: Call;
  className?: string;
}

export const ConnectionQuality: FC<ICallTimeProps> = observer(({ call }) => {
  if (!call) {
    return null;
  }

  if (call.connectionQuality === CallConnectionQuality.Poor) {
    return (
      <IconView
        Icon={IcNetworkPoor16Icon}
        className={styles.icon}
        size={IconViewSizes.Small}
      />
    );
  }

  if (call.connectionQuality === CallConnectionQuality.Good) {
    return (
      <IconView
        Icon={IcNetworkGood16Icon}
        className={styles.icon}
        size={IconViewSizes.Small}
      />
    );
  }
  if (call.connectionQuality === CallConnectionQuality.Excellent) {
    return (
      <IconView
        Icon={IcNetwork16Icon}
        className={styles.icon}
        size={IconViewSizes.Small}
      />
    );
  }
  return null;
});
